(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["case-links-showcase"] && !Shopify.designMode) return;
  try {
    
  function initCaseLinksGallery(root) {
    if (!root || root.dataset.caseGalleryReady === 'true') return;
    root.dataset.caseGalleryReady = 'true';

    const source = root.querySelector('[data-case-source]');
    const grid = root.querySelector('[data-case-grid]');
    const status = root.querySelector('[data-case-status]');
    const empty = root.querySelector('[data-case-empty]');
    const countOutput = root.querySelector('[data-case-visible-count]');
    const searchInput = root.querySelector('[data-case-search]');
    const categorySelect = root.querySelector('[data-case-category-select]');
    const defaultCategory = root.dataset.defaultCategory || '未分类';
    const maxLinks = Number.parseInt(root.dataset.maxLinks || '500', 10);
    const shouldDeduplicate = root.dataset.deduplicate === 'true';
    const screenshotProvider = root.dataset.screenshotProvider || 'thumio';
    const customTemplate = root.dataset.customTemplate || '';
    const screenshotWidth = root.dataset.shotWidth || '900';
    const screenshotHeight = root.dataset.shotHeight || '560';
    const screenshotMaxAge = root.dataset.shotMaxAge || '168';
    const screenshotFallback = root.dataset.shotFallback === 'true';
    const screenshotConcurrency = Math.max(1, Number.parseInt(root.dataset.shotConcurrency || '3', 10));
    const unavailableLabel = root.dataset.unavailableLabel || '该网站限制自动预览';

    if (!source || !grid) return;

    const clone = source.cloneNode(true);
    clone.hidden = false;
    clone.querySelectorAll('a[href]').forEach((anchor) => {
      const href = anchor.getAttribute('href') || '';
      if (!/^https?:\/\//i.test(href)) return;
      if (!/^https?:\/\//i.test(anchor.textContent.trim())) {
        anchor.textContent = `${href} ${anchor.textContent.trim()}`;
      }
    });

    const rawLines = (clone.innerText || clone.textContent || '')
      .replace(/\u00a0/g, ' ')
      .split(/\r?\n/)
      .map((line) => line.trim())
      .filter(Boolean);

    const cases = [];
    const seen = new Set();
    let currentCategory = defaultCategory;

    rawLines.forEach((line) => {
      if (cases.length >= maxLinks) return;
      const matches = Array.from(line.matchAll(/https?:\/\/[^\s<>"']+/gi));

      if (matches.length === 0) {
        currentCategory = line.replace(/^[#\-–—\s]+|[:：\s]+$/g, '').trim() || defaultCategory;
        return;
      }

      matches.forEach((match, index) => {
        if (cases.length >= maxLinks) return;
        const rawUrl = match[0].replace(/[),.;，。；、】》]+$/g, '');

        let parsedUrl;
        try {
          parsedUrl = new URL(rawUrl);
        } catch (error) {
          return;
        }

        if (!/^https?:$/.test(parsedUrl.protocol)) return;
        const normalizedUrl = parsedUrl.href;
        if (shouldDeduplicate && seen.has(normalizedUrl)) return;
        seen.add(normalizedUrl);

        const nextStart = index + 1 < matches.length ? matches[index + 1].index : line.length;
        const annotation = line
          .slice(match.index + match[0].length, nextStart)
          .replace(/^[\s|｜,:：;；\-–—]+|[\s|｜,:：;；\-–—]+$/g, '')
          .trim();
        const domain = parsedUrl.hostname.replace(/^www\./i, '');

        cases.push({
          url: normalizedUrl,
          origin: parsedUrl.origin,
          domain,
          title: domain,
          category: currentCategory,
          annotation
        });
      });
    });

    const categories = Array.from(new Set(cases.map((item) => item.category)));
    categories.forEach((category) => {
      if (!categorySelect) return;
      const option = document.createElement('option');
      option.value = category;
      option.textContent = category;
      categorySelect.appendChild(option);
    });

    const screenshotSourcesFor = (url) => {
      const encoded = encodeURIComponent(url);
      const thumio = {
        type: 'thumio',
        url: `https://image.thum.io/get/width/${screenshotWidth}/crop/${screenshotHeight}/maxAge/${screenshotMaxAge}/allowJPG/noanimate/?url=${encoded}`
      };
      const mshots = {
        type: 'mshots',
        url: `https://s0.wordpress.com/mshots/v1/${encoded}?w=${screenshotWidth}&h=${screenshotHeight}`
      };

      if (screenshotProvider === 'custom' && customTemplate.includes('{url}')) {
        return [{
          type: 'custom',
          url: customTemplate
            .replaceAll('{url}', encoded)
            .replaceAll('{width}', screenshotWidth)
            .replaceAll('{height}', screenshotHeight)
        }];
      }

      if (screenshotProvider === 'none') return [];
      if (screenshotProvider === 'mshots') return screenshotFallback ? [mshots, thumio] : [mshots];
      return screenshotFallback ? [thumio, mshots] : [thumio];
    };

    const pendingImages = [];
    let activeImageRequests = 0;

    const markPreviewUnavailable = (image, reason) => {
      const media = image.closest('.case-links-gallery__media');
      if (!media) return;
      media.classList.add('is-unavailable');
      image.remove();
      const output = media.querySelector('[data-preview-status]');
      if (output) output.textContent = reason || unavailableLabel;
    };

    const showBlob = (image, blob) => new Promise((resolve, reject) => {
      const media = image.closest('.case-links-gallery__media');
      const objectUrl = URL.createObjectURL(blob);
      image.onload = () => {
        media?.classList.add('is-loaded');
        URL.revokeObjectURL(objectUrl);
        resolve();
      };
      image.onerror = () => {
        URL.revokeObjectURL(objectUrl);
        reject(new Error('image_decode_failed'));
      };
      image.src = objectUrl;
    });

    const fetchScreenshot = async (image, source) => {
      if (source.type === 'custom') {
        await new Promise((resolve, reject) => {
          const media = image.closest('.case-links-gallery__media');
          image.onload = () => {
            media?.classList.add('is-loaded');
            resolve();
          };
          image.onerror = () => reject(new Error('custom_provider_failed'));
          image.src = source.url;
        });
        return;
      }

      const response = await fetch(source.url, {
        mode: 'cors',
        credentials: 'omit',
        cache: 'force-cache'
      });

      if (!response.ok) throw new Error(`provider_${response.status}`);

      if (source.type === 'thumio') {
        const targetStatus = Number.parseInt(response.headers.get('thum_status_code') || '200', 10);
        if (targetStatus >= 400) {
          const error = new Error(`target_${targetStatus}`);
          error.targetStatus = targetStatus;
          throw error;
        }
      }

      await showBlob(image, await response.blob());
    };

    const loadQueuedImage = async (image) => {
      const sources = JSON.parse(image.dataset.sources || '[]');
      let lastError;

      for (const source of sources) {
        try {
          await fetchScreenshot(image, source);
          return;
        } catch (error) {
          lastError = error;
          if (error.targetStatus === 404 || error.targetStatus === 403 || error.targetStatus === 429) break;
        }
      }

      markPreviewUnavailable(image, unavailableLabel);
      if (lastError) image.dataset.previewError = lastError.message;
    };

    const runImageQueue = () => {
      while (activeImageRequests < screenshotConcurrency && pendingImages.length > 0) {
        const image = pendingImages.shift();
        if (!image?.isConnected) continue;
        activeImageRequests += 1;
        loadQueuedImage(image).finally(() => {
          activeImageRequests -= 1;
          runImageQueue();
        });
      }
    };

    const queueImage = (image) => {
      if (image.dataset.queued === 'true') return;
      image.dataset.queued = 'true';
      pendingImages.push(image);
      runImageQueue();
    };

    const imageObserver = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            queueImage(entry.target);
            observer.unobserve(entry.target);
          });
        }, { rootMargin: '500px 0px' })
      : null;

    const fragment = document.createDocumentFragment();

    cases.forEach((item, index) => {
      const card = document.createElement('article');
      card.className = 'case-links-gallery__card';
      card.dataset.caseCard = '';
      card.dataset.category = item.category;
      card.dataset.searchText = `${item.domain} ${item.category} ${item.annotation}`.toLocaleLowerCase();
      card.style.viewTransitionName = `case-link-card-${index + 1}`;

      const link = document.createElement('a');
      link.className = 'case-links-gallery__link';
      link.href = item.url;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      link.setAttribute('aria-label', `查看案例：${item.domain}`);

      const media = document.createElement('div');
      media.className = 'case-links-gallery__media';

      const placeholder = document.createElement('div');
      placeholder.className = 'case-links-gallery__placeholder';
      placeholder.setAttribute('aria-hidden', 'true');

      const initial = document.createElement('strong');
      initial.textContent = item.domain.slice(0, 1).toUpperCase();
      const favicon = document.createElement('img');
      favicon.className = 'case-links-gallery__favicon';
      favicon.src = `${item.origin}/favicon.ico`;
      favicon.alt = '';
      favicon.width = 64;
      favicon.height = 64;
      favicon.loading = 'lazy';
      favicon.referrerPolicy = 'no-referrer';
      favicon.addEventListener('load', () => {
        if (favicon.naturalWidth > 4) favicon.classList.add('is-loaded');
      }, { once: true });
      const placeholderDomain = document.createElement('span');
      placeholderDomain.textContent = item.domain;
      const previewStatus = document.createElement('small');
      previewStatus.className = 'case-links-gallery__preview-status';
      previewStatus.dataset.previewStatus = '';
      placeholder.append(initial, favicon, placeholderDomain, previewStatus);
      media.appendChild(placeholder);

      const screenshotSources = screenshotSourcesFor(item.url);
      if (screenshotSources.length > 0) {
        const image = document.createElement('img');
        image.className = 'case-links-gallery__image';
        image.alt = `${item.domain} 网站截图`;
        image.width = Number.parseInt(screenshotWidth, 10);
        image.height = Number.parseInt(screenshotHeight, 10);
        image.loading = 'lazy';
        image.referrerPolicy = 'no-referrer';
        image.dataset.sources = JSON.stringify(screenshotSources);
        media.appendChild(image);
        if (imageObserver) imageObserver.observe(image);
        else queueImage(image);
      }

      const category = document.createElement('span');
      category.className = 'case-links-gallery__category';
      category.textContent = item.category;
      media.appendChild(category);

      const overlay = document.createElement('span');
      overlay.className = 'case-links-gallery__overlay';
      overlay.setAttribute('aria-hidden', 'true');
      const visit = document.createElement('span');
      visit.className = 'case-links-gallery__visit';
      visit.textContent = '查看网站 ↗';
      overlay.appendChild(visit);
      media.appendChild(overlay);

      const info = document.createElement('div');
      info.className = 'case-links-gallery__info';
      const title = document.createElement('h2');
      title.className = 'case-links-gallery__title';
      title.textContent = item.title;
      const urlText = document.createElement('p');
      urlText.className = 'case-links-gallery__url';
      urlText.textContent = item.url;
      info.append(title, urlText);

      if (item.annotation) {
        const annotation = document.createElement('p');
        annotation.className = 'case-links-gallery__annotation';
        annotation.textContent = item.annotation;
        info.appendChild(annotation);
      }

      link.append(media, info);
      card.appendChild(link);
      fragment.appendChild(card);
    });

    grid.appendChild(fragment);
    status.hidden = true;

    const updateResults = () => {
      const query = (searchInput?.value || '').trim().toLocaleLowerCase();
      const selectedCategory = categorySelect?.value || 'all';
      let visible = 0;

      grid.querySelectorAll('[data-case-card]').forEach((card) => {
        const matchesSearch = !query || card.dataset.searchText.includes(query);
        const matchesCategory = selectedCategory === 'all' || card.dataset.category === selectedCategory;
        const show = matchesSearch && matchesCategory;
        card.hidden = !show;
        if (show) visible += 1;
      });

      countOutput.textContent = visible;
      empty.hidden = visible !== 0;
    };

    searchInput?.addEventListener('input', updateResults);
    categorySelect?.addEventListener('change', updateResults);
    updateResults();
  }

  document.querySelectorAll('[data-case-gallery]').forEach(initCaseLinksGallery);

  document.addEventListener('shopify:section:load', (event) => {
    initCaseLinksGallery(event.target.querySelector('[data-case-gallery]'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-1"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-3"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });


  document.addEventListener("DOMContentLoaded", function () {
    const dropdownBtn = document.getElementById("verticalDropdownBtn");
    const dropdownContent = document.getElementById("verticalDropdownContent");
   
    dropdownBtn?.addEventListener("click", function () {
      dropdownContent.classList.toggle("show");
    });

    window.addEventListener("click", function (event) {
      if (!dropdownBtn?.contains(event.target) && !dropdownContent?.contains(event.target)) {
        dropdownContent?.classList.remove("show");
      }
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-4"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const headerElement = document.getElementById('shopify-section--header'),
      headerHeight = headerElement.clientHeight,
      headerHeightWithoutBottomNav = headerElement.querySelector('.header_wrapper').clientHeight;

    document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
    document.documentElement.style.setProperty('--header-height-without-bottom-nav', headerHeightWithoutBottomNav + 'px');
  });

  } catch(e) { console.error(e); }
})();
})();
